
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X, ArrowRight } from "lucide-react";
import { SmartSuggestion } from "@/hooks/use-smart-suggestions";

interface SmartSuggestionsProps {
  suggestions: SmartSuggestion[];
  onDismiss: (suggestionId: string) => void;
}

export function SmartSuggestions({ suggestions, onDismiss }: SmartSuggestionsProps) {
  const navigate = useNavigate();

  if (suggestions.length === 0) return null;

  const handleAction = (suggestion: SmartSuggestion) => {
    navigate(suggestion.action);
    onDismiss(suggestion.id);
  };

  return (
    <div className="space-y-3">
      {suggestions.map((suggestion) => (
        <Card key={suggestion.id} className="bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <div className="text-2xl">{suggestion.icon}</div>
              <div className="flex-1">
                <h4 className="font-semibold text-blue-900 mb-1">{suggestion.title}</h4>
                <p className="text-sm text-blue-700 mb-3">{suggestion.description}</p>
                <Button
                  size="sm"
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                  onClick={() => handleAction(suggestion)}
                >
                  {suggestion.actionText}
                  <ArrowRight className="h-3 w-3 ml-1" />
                </Button>
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="h-6 w-6 p-0 text-blue-600 hover:bg-blue-100"
                onClick={() => onDismiss(suggestion.id)}
              >
                <X className="h-3 w-3" />
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
